import { useEffect } from 'react';
import type { BlockDefinition, BlockProps } from '../../types';
import type { ComponentContentSchema } from '@vibesites/runtime';
import { useBlockToken } from '@vibesites/runtime/react';
import { useTrackingAllowed } from '../../shared/analytics';
import { injectTikTokPixel } from './inject';
import { resolveTikTokPixel } from './resolve';

function TikTokPixelComponent(_props: BlockProps) {
  const pixel = useBlockToken('pixel', { defaultValue: '' });
  const trackingAllowed = useTrackingAllowed('advertising');

  useEffect(() => {
    if (!trackingAllowed) return;
    const config = resolveTikTokPixel(pixel);
    if (!config) return;
    injectTikTokPixel(config);
  }, [trackingAllowed, pixel]);

  return null;
}

const contentSchema: ComponentContentSchema = {
  slot: 'TikTokPixel',
  displayName: 'TikTok Pixel',
  tokens: {
    pixel: {
      label: 'Pixel ID or script',
      type: 'text',
      description:
        'TikTok Pixel ID (e.g. DA6BTUBC77UC8FLJ3QS0), or the full Pixel snippet from TikTok Ads Manager.',
      required: true,
    },
  },
};

export const tiktokPixelBlock: BlockDefinition = {
  id: 'tiktok-pixel',
  name: 'TikTok Pixel',
  description:
    'TikTok conversion tracking pixel. Accepts a pixel ID or the full official snippet and injects it into the page head.',
  category: 'Analytics',
  placement: 'injection',
  defaultScope: 'global',
  component: TikTokPixelComponent,
  contentSchema,
  tags: ['tiktok', 'pixel', 'tracking', 'ads', 'conversion'],
};
